import router from '../../router';

export default class RouterUtils {
  public static async goTo(path: string): Promise<void> {
    await router.push(path).catch((error) => {
      this.ignoreNavDuplicated(error);
    });
  }

  /**
   * ルーター名に移動する。
   *
   * @param {string} routerName ルーター名
   */
  public static async goToRouterName(routerName: string): Promise<void> {
    await router.push({ name: routerName }).catch((error) => {
      this.ignoreNavDuplicated(error);
    });
  }

  /**
   * リプレースルーター名。
   *
   * @param {string} routerName ルーター名
   */
  public static async replaceRouterName(routerName: string): Promise<void> {
    await router.replace({ name: routerName }).catch((error) => {
      this.ignoreNavDuplicated(error);
    });
  }

  /**
   * ナビゲーションの重複エラーを処理するための静的メソッド。
   *
   * @param {Error} error エラーオブジェクト
   */
  private static ignoreNavDuplicated(error: Error): void {
    if (
      error.name !== 'NavigationDuplicated' &&
      !error.message.includes('Avoided redundant navigation to current location')
    ) {
      console.log(error);
    }
  }
}
